import React from 'react'
import './Partner.css'
const Partner = ({img}) => {
  return (
    <div className='partner'><img src={img} alt='partner'/></div>
  )
}

export default Partner